const glasses = [require('../../images/glasses/0.png')]
module.exports = { glasses };